import Nango from '@nangohq/frontend';

export default {
  Nango: {
    mounted() {
      this.handle();
    },

    updated() {
      this.handle();
    },

    handle() {
      this.connectionId = this.el.dataset.connectionId;
      this.publicKey = this.el.dataset.publicKey;
      this.provider = this.el.dataset.provider;

      const nango = new Nango({ publicKey: this.publicKey });

      nango
        .auth(this.provider, this.connectionId)
        .then(() => {
          this.pushEvent('nango-connected', { connection_id: this.connectionId, provider: this.provider });
        })
        .catch(err => {
          this.pushEvent('nango-error', { reason: err });
        });
    },
  },
};
